var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLc = function SvgLc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#65cfff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 41.991l162.66 395.3-322.6.91L318.9 41.991z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.09 96.516l140.67 339.99-278.99.78 138.32-340.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 240.1l162.66 197.64-322.6.46L318.9 240.1z",
    fill: "#ffce00"
  }))));
};
export default __webpack_public_path__ + "assets/460c25b1c8d6a51687103990cd75cfcd.svg";
export { SvgLc as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/lc.svg